import { useNavigate } from "react-router-dom";
import { toastService } from "../../providers";
import { useRequestPasswordReset } from "../../hooks/queries/useAuthQueries";
import RequestResetEmail from "../../components/auth/RequestResetEmail/RequestResetEmail";

function RequestPasswordReset() {
  const navigate = useNavigate();
  const { mutate: requestPasswordResetMutation, isPending } =
    useRequestPasswordReset();

  const handleSubmit = (email) => {
    requestPasswordResetMutation(email, {
      onSuccess: () => {
        toastService.success("Reset link sent to your email");
        setTimeout(() => {
          navigate("/auth/login");
        }, 1000);
      },
      onError: (_error) => {
        toastService.error("Failed to send reset link");
      },
    });
  };

  return (
    <RequestResetEmail
      title="Forgot Password"
      subtitle="Enter your email to receive a reset link"
      buttonLabel="Recover my account"
      onSubmit={handleSubmit}
      isPending={isPending}
    />
  );
}

export default RequestPasswordReset;
